export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51SjEKxRzATxviVESwEjT031uDJg31OFCrCYKNInMgKb5g3pMAid5710kA6qXiiKPiUL47I9O3F6fwohEgCNw8Ojg00Mp5849kO';